import React, { useRef, useState } from "react"
import { Button, IconButton, Tooltip } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import AddIcon from "@mui/icons-material/Add"
import "./Inspeccion.css"

const Inspeccion = ({ inspecciones = [], setInspecciones, guardarInspeccion, loadingButton = false }) => {
  const [inspeccion, setInspeccion] = useState("")
  const inputRef = useRef(null)
  const hayTexto = inspeccion.trim().length > 0

  const addInspeccion = () => {
    const texto = inspeccion.trim()
    if (!texto || loadingButton) return
    setInspecciones((prev) => [...prev, { inspeccion: texto }])
    setInspeccion("")
    inputRef.current?.focus()
  }

  const deleteInspeccion = (index) => {
    setInspecciones((prev) => prev.filter((_, position) => position !== index))
  }

  return (
    <section className="service-inspections" aria-labelledby="inspections-title">
      <div className="service-inspections__panel">
        <header className="service-inspections__header">
          <h2 id="inspections-title">Inspecciones y diagnósticos</h2>
          <p>Registra lo que observaste al revisar la unidad y las causas que hayas identificado.</p>
        </header>
        <div className="service-inspections__entry">
          <label htmlFor="inspection-detail">Detalle encontrado</label>
          <textarea
            id="inspection-detail"
            ref={inputRef}
            rows={3}
            value={inspeccion}
            disabled={loadingButton}
            onChange={(event) => setInspeccion(event.target.value)}
            placeholder="Ej. La unidad llegó llena de lodo. Se observa una pieza raspada en la parte inferior."
            aria-describedby="inspection-help"
          />
          <div className="service-inspections__entry-actions">
            <p id="inspection-help">Describe un hallazgo por registro e indica la pieza o zona revisada.</p>
            <Button variant="outlined" startIcon={<AddIcon />} disabled={!hayTexto || loadingButton} onClick={addInspeccion}>
              Agregar detalle
            </Button>
          </div>
        </div>
        <div className="service-inspections__list-header">
          <h3>Detalles registrados</h3>
          <span>{inspecciones.length}</span>
        </div>
        {inspecciones.length > 0 ? (
          <ol className="service-inspections__list">
            {inspecciones.map((item, index) => (
              <li key={item.idInspeccion ?? index}>
                <span className="service-inspections__number" aria-hidden="true">{index + 1}</span>
                <p>{item.inspeccion}</p>
                <Tooltip title="Eliminar detalle">
                  <span>
                    <IconButton aria-label={`Eliminar detalle ${index + 1}`} disabled={loadingButton} onClick={() => deleteInspeccion(index)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </li>
            ))}
          </ol>
        ) : (
          <p className="service-inspections__empty">Aún no hay detalles registrados. Agrega el primer hallazgo de la revisión.</p>
        )}
        <footer className="service-inspections__actions">
          <p>{hayTexto ? "Agrega el detalle escrito antes de guardar." : "Guarda para conservar los cambios en la orden."}</p>
          <LoadingButton variant="contained" loading={loadingButton} disabled={hayTexto} onClick={guardarInspeccion}>
            GUARDAR
          </LoadingButton>
        </footer>
      </div>
    </section>
  )
}

export default Inspeccion
